import { useCallback, useMemo, useRef } from 'react';

import { ValidationContext } from './ValidationContext';

export function ValidationProvider({ children }) {
  const validatorsRef = useRef<(() => boolean)[]>([]);

  const registerValidation = useCallback((fn: () => boolean) => {
    validatorsRef.current.push(fn);
  }, []);

  const triggerValidation = useCallback(() => {
    let isValid = true;
    validatorsRef.current.forEach((fn) => {
      if (!fn()) {
        isValid = false;
      }
    });
    return isValid;
  }, []);

  const contextValue = useMemo(
    () => ({ registerValidation, triggerValidation }),
    [registerValidation, triggerValidation]
  );

  return <ValidationContext.Provider value={contextValue}>{children}</ValidationContext.Provider>;
}
